<template lang="pug">
main#v-about: .container
  h1
    span 2019
    |
    | 智慧製造線上特展
  h2
    | 備戰 5G 時代
    br
    | 台灣供應鏈轉型下一步
  p 2025年全球5G市場規模將上看2,510億美元，高傳輸、低延遲的連網特色，即將帶動海量物聯網與智慧製造的創新應用。TechOrange 科技報橘針對台灣智慧製造未來發展契機，策劃一系列實體與線上特展，集結台灣產官學界專家，共同激盪 5G 時代的台灣製造創新出路。
  .arrow(@click='$scrollTo("#topics", { offset: -$store.state.scroll.offset })')
</template>

<script>
export default {
  name: 'About',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

@keyframes arrow
  0%
    transform: translateY(0)
  50%
    transform: translateY(-8px)
  100%
    transform: translateY(0)

#v-about
  +background((url(~@/assets/background-1.png), url(~@/assets/gear.png), url(~@/assets/background-2.png)), (460px, 400px, 500px), no-repeat, (calc(50% - 410px) 450px, calc(50% - 120px) 20px, calc(50% + 390px) 70px))
  background-color: #222937
  padding-bottom: 120px
  padding-top: 80px
h1
  +font(28px, #FFA029, null, 2px, bold)
  margin-bottom: 15px
  span
    +font(32px, null, null, null, 900)
    font-family: Roboto
    font-style: italic
h2
  +font(42px, white, 55px, 3px, bold)
  margin-bottom: 28px
p
  +font(16px, #DADADA, 30px, null, 500, justify)
  margin-bottom: 130px
  width: 520px
.arrow
  +flex(center, center)
  +size(25px)
  animation: arrow .8s infinite
  cursor: pointer
  margin-left: auto
  margin-right: auto
  position: relative
  &::before, &::after
    +size(16px, 3px)
    background-color: white
    content: ''
    position: absolute
  &::before
    transform: translate(-5px) rotate(45deg)
  &::after
    transform: translate(5px) rotate(-45deg)

@media (max-width: 1023px)
  #v-about
    +background((url(~@/assets/m-background-1.png), url(~@/assets/gear.png), url(~@/assets/m-background-2.png)), (180px, 222px, 260px), no-repeat, (right top, center top 60px, left top 260px))
    padding-bottom: 50px
    padding-top: 110px
  h1
    +font(18px, null, null, .22px, null, center)
    margin-bottom: 12px
    span
      font-size: 20px
  h2
    +font(24px, null, 32px, .44px, null, center)
    margin-bottom: 136px
  p
    +font(12px, #DADADA, 20px, .69px)
    margin: 0 auto 38px
    width: 280px
</style>
